import { t } from 'i18next'

/**
 * Statuses this queue actually produces. The shared campaign-list catalog
 * also offers `awaiting_approval`, whose label matches the column for
 * `pending_review` (`rm:awaitingApproval`) — picking it filters to a value
 * the backend never writes and empties the table.
 *
 * `pending_review` uses the same label as `campaignStatusBadge`, so the
 * option the advertiser reads in the column is the one that hits the API.
 */
export const offsiteAdvertiserReviewStatusFilterOptions = [
  { value: 'pending_review', label: t('rm:awaitingApproval') },
  { value: 'approved', label: t('rm:approved') },
  { value: 'rejected', label: t('rm:rejected') },
  { value: 'awaiting_publication', label: t('rm:awaitingPublication') },
  { value: 'finished', label: t('rm:finished') }
]
